import { Event } from "../../../types";
import { EventDetailsCards } from "./EventDetailsCards";
import { EventContentSections } from "./EventContentSections";
import { SessionsTable } from "./SessionsTable";
import { PaymentSummary } from "./PaymentSummary";

interface EventOverviewTabContentProps {
  event: Event;
}

export default function EventOverviewTabContent({ event }: EventOverviewTabContentProps) {
  return (
    <div className="flex flex-col" data-testid="event-overview-content">
      <div className="grid grid-cols-1 md:grid-cols-12 sm:gap-12">
        <div className="col-span-1 md:col-span-4 mt-12">
          <EventDetailsCards event={event} />
        </div>
        <div className="col-span-1 md:col-span-8 sm:mt-7">
          <EventContentSections event={event} />
        </div>
      </div>

      <div className="col-span-1 md:col-span-12">
        <SessionsTable event={event} />
      </div>

      <div className="col-span-1 md:col-span-12">
        <PaymentSummary event={event} />
      </div>
    </div>
  );
}
